import React, {forwardRef} from 'react';
import {OrderModel} from "../../pages/shared/models/order/order-item.model";
import {PolandExportTemplate} from "./templates/poland-export-template";
import {OrderPaidExportTemplate} from "./templates/order-paid-export-template";
import {OrderUnpaidExportTemplate} from "./templates/order-unpaid-export-template";
import { OrderPaymentStatusNames } from "../../actions/types";

const Template = forwardRef(({order, variant}: TemplateProps, ref:  React.ForwardedRef<any>) => {
    function getTemplate() {
        
        if (order) {
            switch (variant) {
                case OrderPaymentStatusNames.WAREHOUSE:
                    return <PolandExportTemplate order={order}/>
                case OrderPaymentStatusNames.UNPAID:
                    return <OrderUnpaidExportTemplate order={order}/>
                case OrderPaymentStatusNames.PAID:
                    return <OrderPaidExportTemplate order={order}/>
            }
        } else {
            return <></>
        }
    }
    return (
        <div ref={ref}>
            {getTemplate()}
        </div>
    );
});

interface TemplateProps {
    order?: OrderModel,
    variant: OrderPaymentStatusNames,
}

export default Template;
